<template>
  <data-list
    ref="dataList"
    class="content md"
    :url="url"
    :entity-name="title"
    hide-action
    :action="action"
    :columns="columns"
    :modal-width="640"
    :modal-form="{
      layout: 'horizontal',
      labelAlign: 'left',
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    }"
    :search-key-type="searchKeyType"
  >
    <template v-slot:query="{ form }">
      <a-form-model-item label="提交人">
        <select-book type="user" v-model="form.wx_user_id" @change="updateList"></select-book>
      </a-form-model-item>
      <a-form-model-item label="提交时间">
        <a-range-picker
          v-model="form.create_time"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          allow-clear
          @change="updateList"
          class="range-picker date"
        />
      </a-form-model-item>
    </template>
    <template v-slot:button="{ form }">
      <a-button type="primary" @click="exportData(form)" :loading="exporting">
        {{ exporting ? "正在导出" : "数据导出" }}
      </a-button>
    </template>
  </data-list>
</template>

<script>
import { getTemple } from "@/common/js/storage";
import { downLoadBlobFile } from "@/common/js/tool";

const typeMap = {
  maintenance: "设备维护保养",
  disinfect: "食堂消毒",
  hygiene: "斋堂日常卫生检查",
  "device-clean": "设备清洗",
};

export default {
  name: "RefectoryRecord",
  data() {
    return {
      columns: [
        { title: "提交时间", dataIndex: "create_time" },
        {
          title: "提交人",
          dataIndex: "wx_user_id",
          customRender: (text) => <open-data type="userName" openid={text} />,
        },
      ],
      searchKeyType: {
        create_time: (form, key) => {
          let res = "";
          const value = form[key];
          if (value?.length === 2) {
            res = `&filter[create_time][gte]=${value[0]} 00:00:00&&filter[create_time][lte]=${value[1]} 23:59:59`;
          }
          return res;
        },
      },
      exporting: false,
    };
  },
  computed: {
    type() {
      return this.$route.query.type;
    },
    url() {
      return this.type ? `/admin/record-${this.type}` : "";
    },
    title() {
      let res = `${typeMap[this.type]}记录`;
      document.title = res;
      return res;
    },
    action() {
      return this.$route.meta.action;
    },
  },
  methods: {
    updateList() {
      this.$refs.dataList.updateList();
    },
    exportData(form) {
      if (this.exporting) return;
      this.exporting = true;
      const temple = getTemple();
      let url = `${this.url}/export?temple_id=${temple}`;
      if (form.create_time?.length === 2) {
        url += `&start_time=${form.create_time[0]}&end_time=${form.create_time[1]}`;
      }
      if (form.wx_user_id) {
        url += `&wx_user_id=${form.wx_user_id}`;
      }
      this.$axios(url, { noTempleFilter: true, responseType: "blob" })
        .then((res) => {
          downLoadBlobFile(res, this.title);
        })
        .finally(() => {
          this.exporting = false;
        });
    },
  },
};
</script>

<style lang="less" scoped></style>
